import { useState } from 'react';
export const useAccordionState = (options) => {
    const [openedItems, setOpen] = useState([]);
    const moveTo = (ref, openItemId) => {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (openItemId) {
            if (!options.multiOpen) {
                setOpen([openItemId]);
            }
            else if (openedItems.indexOf(openItemId) === -1) {
                setOpen([...openedItems, openItemId]);
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onToggle = (itemId) => {
        if (!options.multiOpen) {
            setOpen(openedItems.indexOf(itemId) === -1 ? [itemId] : []);
        }
        else if (openedItems.indexOf(itemId) !== -1) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setOpen([...openedItems.filter((val) => val !== itemId)]);
        }
        else {
            setOpen([...openedItems, itemId]);
        }
    };
    const onToggleAll = (itemIds) => {
        setOpen(itemIds);
    };
    return {
        moveTo: moveTo,
        openedItems,
        onToggle,
        onToggleAll,
    };
};
//# sourceMappingURL=hooks.js.map